import { GeneSetsFilterOption } from '../types';
import { GeneSetSelection } from '../../components';

export const config: GeneSetsFilterOption = {
  id: 'omicsExplorer.filters.geneSets',
  title: {
    id: 'omicsExplorer.filters.geneSets',
    defaultMessage: 'Gene Sets',
  },
  content: GeneSetSelection,
  injectedProps: {
    searchKey: 'gene',
  },
};
